/**
 * Mission archetypes for exceptional convoy tenders.
 * Centralised here so both `exceptionalTenders.js` (AO catalogue) and
 * `convoyExceptionnelSlice.js` (mission resolution) reference the same
 * archetype IDs and cargo descriptions.
 */
export const MISSION_ARCHETYPES_FOR_TENDERS = {
  'wind-turbine': {
    cargo: 'Pale d\'éolienne offshore',
    client: 'NordVent Énergie',
    distance: 420,
    pressAngle: 'transition_energy',
  },
  'rocket-stage': {
    cargo: 'Étage de fusée Ariane',
    client: 'ArianeSpace Logistics',
    distance: 380,
    pressAngle: 'aerospace_prestige',
  },
  'prefab-house': {
    cargo: 'Maison modulaire 12×4 m',
    client: 'Maisons Préfabri Pro',
    distance: 280,
    pressAngle: 'innovative_housing',
  },
  'industrial-press': {
    cargo: 'Presse hydraulique 45T',
    client: 'SteelForge Industries',
    distance: 510,
    pressAngle: 'industrial_renaissance',
  },
  'yacht-hull': {
    cargo: 'Coque de yacht 22 m',
    client: 'Chantiers Bénéteau Plaisance',
    distance: 340,
    pressAngle: 'luxury_lifestyle',
  },
};
